module.exports = __webpack_public_path__ + "img/biobank-logo.9ec947ac.png";